import React, { useState, useContext, useCallback, useEffect } from 'react';

import PresentPC from 'components/pages/Input/PresentPC';
import PresentSP from 'components/pages/Input/PresentSP';
import AppContext from 'fluxes/context';

import TextInput from 'components/atoms/Input/TextInput';
import TextAreaInput from 'components/atoms/Input/TextAreaInput';
import BasicCheckBoxInput from 'components/atoms/Input/BasicCheckBoxInput';
import PcErrorArea from 'components/molecules/PcErrorArea';
import PcSuggestList from 'components/molecules/PcSuggestList';
import SpSuggestList from 'components/molecules/SpSuggestList';

import {
  UPDATE_INPUT,
  UPDATE_ADD_INPUT,
  RESET_INPUT,
  RESET_ADD_INPUT,
  CHANGE_VALID,
  RESET_INPUT_COMMON,
  UPDATE_INPUT_COMMON,
} from 'fluxes/actions';

import {
  useWindowDimensions,
  useIECheck,
  sortErrors,
  useDirectTransCheck,
  isSchemaValid,
  MoveCheckStart,
  MoveCheckStop,
  isFatalApiError,
  ErrorMessage,
  scrollTop,
  getCookies,
  isCustomValid,
  changeStr,
} from 'utils';

import MeasureEvent from 'utils/measureEvent';

import {
  ekiSuggestApi,
} from 'utils/api';

import {
  CHOICES_MAP,
  CUSTOM_ERROR_MESSAGES,
  CHOICES_NAME_MAP,
  MEASURE_MAP,
  COMMENT_MAP,
  TEL_TOOL_LINK,
} from 'utils/constant';


const Input = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  
  const[ workCategory, setWorkCategory ] = useState(state.workCategory);
  const[ workCategoryOtherDetail, setWorkCategoryOtherDetail ] = useState(state.workCategoryOtherDetail);

  const [ howToDo, setHowToDo ] = useState(state.howToDo);

  const[ companyNameText, setCompanyNameText ] = useState(state.companyNameText);
  const[ dept, setDept ] = useState(state.dept);
  const[ chargePersonNameText, setChargePersonNameText ] = useState(state.chargePersonNameText);
  const[ tel, setTel ] = useState(state.tel);
  const[ email, setEmail ] = useState(state.email);
  const[ address, setAddress ] = useState(state.address);
  const[ selectedEkiCd, setSelectedEkiCd ] = useState(state.ekiCd);
  const[ ekiCd, setEkiCd ] = useState(state.ekiCd);
  const[ ekiName, setEkiName ] = useState(state.ekiName);
  const[ ekiSuggestNames, setEkiSuggestNames ] = useState([]);
  const[ timerId, setTimerId ] = useState('');
  const[ modalBackIsEnable, setModalBackIsEnable ] = useState(false);
  const[ employmentPlacementDispatching, setEmploymentPlacementDispatching ] = useState(state.employmentPlacementDispatching);
  const[ workDetailText, setWorkDetailText ] = useState(state.workDetailText);
  
  const [ bgdOfRecruitment, setBgdOfRecruitment ] = useState(state.bgdOfRecruitment);
  const [ bgdOfRecruitmentCmnt, setBgdOfRecruitmentCmnt ] = useState(state.bgdOfRecruitmentCmnt);
  const [ desiredStartDateKubun, setDesiredStartDateKubun ] = useState(state.desiredStartDateKubun);
  const [ desiredStartDate, setDesiredStartDate ] = useState(state.desiredStartDate);
  const [ workPeriod, setWorkPeriod ] = useState(state.workPeriod);
  const [ workPeriodDate, setWorkPeriodDate ] = useState(state.workPeriodDate);

  const [ clickID, setClickID ] = useState(state.clickID);
  const [ mediaID, setMediaID ] = useState(state.mediaID);
  const [ showLoading ] = useState(false);
  const [ telToolLink, setTelToolLink ] = useState(false);

  useEffect(() => {
    const domain = document.domain;
    if (domain.match(/^localhost/) || domain.match(/^www-dev./) || domain.match(/^www-stg./)) {
      setTelToolLink(TEL_TOOL_LINK.STG);
    } else if (domain.match(/^www./)) {
      setTelToolLink(TEL_TOOL_LINK.MAIN);
    }
  }, []);

  useEffect(() => {
    setClickID(getCookies('click_id'));
    setMediaID(getCookies('media_id'));
  }, []);

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 直接遷移チェック
  useDirectTransCheck({ state });
  MoveCheckStart();

  // 入力チェック用変数
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [ valids, setValids ] = useState({
    schema: initialValid,
  });
  const [ addInputValids, setAddInputValids ] = useState({ addInputSchema: initialValid });
  const [ inputValids, setInputValids ] = useState({ inputSchema: initialValid, ekiSuggestZero: initialValid });

  // 初期入力チェック設定
  const [ isShowError, setIsShowError ] = useState({
    workCategoryOtherDetail: false,
    companyNameText: false,
    dept: false,
    chargePersonNameText: false,
    tel: false,
    email: false,
    address: false,
    ekiCd: false,
    ekiName: false,
    workDetailText: false,
    bgdOfRecruitmentCmnt: false,
  });
  
  const [ isApiError, setIsApiError ] = useState(false);

  // エラーの画面表示で利用する値
  const valid = Object.keys(valids).every(key => valids[key].valid);
  const addInputValid = Object.keys(addInputValids).every(key => addInputValids[key].valid);
  const inputValid = Object.keys(inputValids).every(key => inputValids[key].valid);

  const dispErrors = useCallback(() => {
    const { schema } = valids;
    const { addInputSchema } = addInputValids;
    const { inputSchema, ekiSuggestZero } = inputValids;
    const errors = sortErrors([
      ...schema.errorMessages,
      ...ekiSuggestZero.errorMessages,
      ...addInputSchema.errorMessages,
      ...inputSchema.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    return errorMap;
  }, [ isShowError, valids, addInputValids, inputValids ]);

  // 入力チェック（全体）
  useEffect(() => {
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path,
      target: {
        workCategory,
        workCategoryOtherDetail,
      },
    });
    // erros更新
    const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
    setValids(org => ({ ...org, ...newValid }));
  }, [ workCategory, workCategoryOtherDetail, valid, path ]);

  // 入力チェック（一般事務選択）
  useEffect(() => {
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:add-input`,
      target: {
        bgdOfRecruitment,
        bgdOfRecruitmentCmnt,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workPeriodDate,
      },
    });
    
    // erros更新
    const newValid = { addInputSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setAddInputValids(org => ({ ...org, ...newValid }));
  }, [ bgdOfRecruitment, bgdOfRecruitmentCmnt, desiredStartDateKubun, desiredStartDate, workPeriod, workPeriodDate, path, valid, workCategory ]);

  // 入力チェック（一般事務以外選択）
  useEffect(() => {
    const [ isValid, newErrorMessages ] = isSchemaValid({
      path: `${path}:-input`,
      target: {
        workDetailText,
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        ekiCd,
        ekiName,
        employmentPlacementDispatching,
      },
    });
    // erros更新
    const newValid = { inputSchema: { valid: isValid, errorMessages: newErrorMessages } };
    setInputValids(org => ({ ...org, ...newValid }));
  }, [
    workDetailText,
    companyNameText,
    dept,
    chargePersonNameText,
    tel,
    email,
    address,
    employmentPlacementDispatching,
    ekiCd,
    ekiName,
    path,
    valid,
    workCategory,
  ]);

  // 就業開始希望日日付指定チェック
  useEffect(()=>{
    const validation = async () => {
    // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkDesiredStartDate' ],
        target: { desiredStartDate, desiredStartDateKubun },
      });
    
      // erros更新
      const newValid = { checkDesiredStartDate: { valid: isValid, errorMessages: newErrorMessages } };
      setAddInputValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ desiredStartDate, desiredStartDateKubun ]);

  // 就業期間日付指定チェック
  useEffect(()=>{
    const validation = async () => {
    // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkwWorkPeriodDate' ],
        target: { workPeriodDate, workPeriod },
      });
    
      // erros更新
      const newValid = { checkwWorkPeriodDate: { valid: isValid, errorMessages: newErrorMessages } };
      setAddInputValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ workPeriodDate, workPeriod ]);


  // 項目入力時 onChange
  const onChangeWorkCategory = (e) =>{
    const val = e.target.value;
    setWorkCategory(val);
    setWorkCategoryOtherDetail('');
    setHowToDo('01');
  };

  const onChangeWorkCategoryOtherDetail = (e) =>{
    setWorkCategoryOtherDetail(e.target.value);
    if(!isShowError.workCategoryOtherDetail) {
      setIsShowError({ ...isShowError, workCategoryOtherDetail: true });
    }
  };

  const howToDoOnChange = (e) => {
    const val = e.target.value;
    setHowToDo(val);
  };

  const onChangeCompanyNameText = async (e) =>{
    setCompanyNameText(e.target.value);
    if(!isShowError.companyNameText) {
      setIsShowError({ ...isShowError, companyNameText: true });
    }
  };

  const onChangeDept = (e) =>{
    setDept(e.target.value);

    if(!isShowError.dept) {
      setIsShowError({ ...isShowError, dept: true });
    }
  };

  const onChangeChargePersonNameText = (e) =>{
    setChargePersonNameText(e.target.value);
    if(!isShowError.chargePersonNameText) {
      setIsShowError({ ...isShowError, chargePersonNameText: true });
    }
  };

  const onChangeTel = (e) =>{
    setTel(e.target.value);

    if(!isShowError.tel) {
      setIsShowError({ ...isShowError, tel: true });
    }
  };

  const onChangeEmail = (e) =>{
    setEmail(e.target.value);

    if(!isShowError.email) {
      setIsShowError({ ...isShowError, email: true });
    }
  };

  const onChangeAddress = (e) =>{
    setAddress(e.target.value);
    if(!isShowError.address) {
      setIsShowError({ ...isShowError, address: true });
    }
  };

  const onChangeEmploymentPlacementDispatching = () =>{
    if (employmentPlacementDispatching) {
      setEmploymentPlacementDispatching(false);
    } else {
      setEmploymentPlacementDispatching(true);
    } 
  };

  const onChangeWorkDetailText = (e) =>{
    setWorkDetailText(e.target.value);
    if(!isShowError.workDetailText) {
      setIsShowError({ ...isShowError, workDetailText: true });
    }
  };

  const bgdOfRecruitmentOnChange = (e) => {
    setBgdOfRecruitment(e.target.value);
    setBgdOfRecruitmentCmnt('');
  };

  const onChangeBgdOfRecruitmentCmnt = (e) => {
    setBgdOfRecruitmentCmnt(e.target.value);
    if(!isShowError.bgdOfRecruitmentCmnt) {
      setIsShowError({ ...isShowError, bgdOfRecruitmentCmnt: true });
    }
  };

  const desiredStartDateOnChange = (e) => {
    if (e.target.value === '01' || e.target.value === '02') {
      setDesiredStartDate();
      setDesiredStartDateKubun(e.target.value);
    }
  };

  const handleChangedesiredStartDate = (e, val) => {
    const date = new Date(
      `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`,
    );
    setDesiredStartDate(changeStr(date));
    setDesiredStartDateKubun(val);
  };

  const workPeriodOnChange = (e) => {
    if (e.target.value === '03' || e.target.value === '02') {
      setWorkPeriodDate();
      setWorkPeriod(e.target.value);
    }
  };
  const handleChangeWorkPeriodDate = (e, val) => {
    const date = new Date(
      `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`,
    );
    setWorkPeriodDate(changeStr(date));
    setWorkPeriod(val);
  };

  // 駅入力
  // サジェスト表示タイマー
  const ekiSuggestTimer = async (searchText) => {
    const id = setTimeout(() => {
      ekiSuggestApi({ searchText }).then((value)=> {
        setEkiSuggestNames(value);
        // サジェストあり
        if(value.length > 0) {
          const newValid = {
            ekiSuggestZero: {
              valid: true,
              errorMessages: [],
            },
          };
          setModalBackIsEnable(true);
          setInputValids(org => ({ ...org, ...newValid }));
        }else{
          setModalBackIsEnable(false);
        }
      }).catch(err => {
        setModalBackIsEnable(false);
        // FATELエラーチェック
        const isFatal = isFatalApiError(err);
        setIsApiError(isFatal);
        if(isFatal) throw err;
        // 駅サジェスト0件
        if(err.response.status === 404){
          setEkiSuggestNames([]);
          // erros更新
          const newValid = {
            ekiSuggestZero: {
              valid: false,
              errorMessages: [ new ErrorMessage('ekiName', CUSTOM_ERROR_MESSAGES.ekiSuggestZero, 1) ],
            },
          };
          setInputValids(org => ({ ...org, ...newValid }));
        } 
        return [];
      });
      // ekiNameエラー表示開始
      if(!isShowError.ekiName) {
        setIsShowError({
          ...isShowError,
          ...{
            ekiName: true,
            ekiCd: true,
          },
        });
      }
    }, 200, searchText);
    return id;
  };

  // 駅名入力時
  const onChangeEkiname = async (e) => {
    // safariのdeleteCompositionTextを無視
    if(e.nativeEvent.inputType === 'deleteCompositionText' || e.nativeEvent.inputType === 'insertFromComposition'){
      return;
    }
    
    const searchText = e.target.value;
    setEkiName(searchText);
    setEkiCd('');
    setSelectedEkiCd('');

    // 先行タイマー停止
    clearTimeout(timerId);
    // タイマー設定
    setTimerId(await ekiSuggestTimer(searchText));
  };

  // 駅サジェストクリック時
  const onClickEkiSuggest = async ( idx ) => {
    const clicked = ekiSuggestNames[idx];
    setEkiName(clicked.ekiNm);
    setEkiCd(clicked.ekiCd);
    setSelectedEkiCd(clicked.ekiCd);
    setEkiSuggestNames([]);
    setModalBackIsEnable(false);
  };

  // ボタン押下
  // state更新処理
  const updateInputCommonState = ()=>{
    dispatch({
      type: UPDATE_INPUT_COMMON,
      updInputCommon: {
        workCategory,
        workCategoryOtherDetail,
        clickID,
        mediaID,
      },
    });
  };
  const updateInputState = ()=>{
    dispatch({
      type: UPDATE_INPUT,
      updInput: {
        workDetailText,
        employmentPlacementDispatching,
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        ekiCd: selectedEkiCd,
        ekiName,
      },
    });
  };

  const updateAddInputState = ()=>{
    dispatch({
      type: UPDATE_ADD_INPUT,
      updAddInput: {
        howToDo,
        bgdOfRecruitment,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        bgdOfRecruitmentCmnt,
        workPeriodDate,
      },
    });
  };

  const resetInputCommonState = () => {
    dispatch({
      type: RESET_INPUT_COMMON,
    });
  };
  const resetInputState = () => {
    dispatch({
      type: RESET_INPUT,
    });
  };
  const resetAddInputState = () => {
    dispatch({
      type: RESET_ADD_INPUT,
    });
  };
  
  const resetState = async () => {
    resetInputCommonState();
    resetInputState();
    resetAddInputState();
  };
  const moveTelTool = () => {
    // イベント計測
    MeasureEvent(
      {
        linkTrackVars: MEASURE_MAP.EVENT_112.linkTrackVars,
        linkTrackEvents: MEASURE_MAP.EVENT_112.linkTrackEvents,
        events: MEASURE_MAP.EVENT_112.events,
      },
      MEASURE_MAP.EVENT_112.name,
    );
    window.location.href = telToolLink;
  };

  const onClickMainButton = {
    nextTel: async () => {
    await resetState()
    .then(()=> MoveCheckStop())
    .then(()=> moveTelTool())
    },
    nextInput: () => {
      // イベント計測
      MeasureEvent(
        {
          linkTrackVars: MEASURE_MAP.EVENT_84.linkTrackVars,
          linkTrackEvents: MEASURE_MAP.EVENT_84.linkTrackEvents,
          events: MEASURE_MAP.EVENT_84.events,
        },
        MEASURE_MAP.EVENT_84.name,
      );
      scrollTop();
      updateInputCommonState();
      updateInputState();
      dispatch({
        type: CHANGE_VALID,
        path,
        valid,
      });
    },
    nextAddInput: () => {
      // イベント計測
      MeasureEvent(
        {
          linkTrackVars: MEASURE_MAP.EVENT_82.linkTrackVars,
          linkTrackEvents: MEASURE_MAP.EVENT_82.linkTrackEvents,
          events: MEASURE_MAP.EVENT_82.events,
        },
        MEASURE_MAP.EVENT_82.name,
      );
      scrollTop();
      updateInputCommonState();
      updateAddInputState();
      dispatch({
        type: CHANGE_VALID,
        path,
        valid,
      });
    },
  };

  // 画面項目
  const {
    workCategoryList,
    serviceArea,
  } = CHOICES_MAP;

  const WorkCategoryList = {
    dataList: workCategoryList,
    serviceArea: serviceArea,
  };

  // 表示用画面項目作成
  const basicInfoList = [
    {
      title: '企業名',
      label: '必須',
      questionMark: false,
      type: 'TextInput',
      input: <>
        <TextInput
          name='companyNameText'
          val={companyNameText}
          onChange={onChangeCompanyNameText}
          placeholder='株式会社リクルートスタッフィング'
          maxLength='300'
          inValid={!!dispErrors().companyNameText}
          suggestText={false}
        />
        <PcErrorArea position='custom' message={dispErrors().companyNameText} />
      </>,
    },
    {
      title: '派遣先部課名',
      label: '必須',
      questionMark: true,
      popUpTitle: '',
      popUpDetail: (
        <span>
          派遣先部課名がない場合は「なし」と入力してください
        </span>),
      type: 'TextInput',
      input: <>
        <TextInput
          name='dept'
          val={dept}
          onChange={onChangeDept}
          placeholder='人事部　人事課'
          maxLength='150'
          inValid={!!dispErrors().dept}
        />
        <PcErrorArea position='custom' message={dispErrors().dept} />
      </>
    },
    {
      title: 'ご担当者名',
      label: '必須',
      questionMark: false,
      type: 'TextInput',
      input: <>
        <TextInput
          name='chargePersonNameText'
          val={chargePersonNameText}
          onChange={onChangeChargePersonNameText}
          placeholder='派遣　太郎'
          maxLength='150'
          inValid={!!dispErrors().chargePersonNameText}
        />
        <PcErrorArea position='custom' message={dispErrors().chargePersonNameText} />
      </>,
    },
    {
      title: '電話番号',
      label: '必須',
      questionMark: false,
      type: 'TextInput',
      input: <>
        <TextInput
          name='tel'
          val={tel}
          onChange={onChangeTel}
          placeholder='090123456789'
          maxLength='13'
          inValid={!!dispErrors().tel}
        />
        <PcErrorArea message={dispErrors().tel} />
      </>,
    },
    {
      title: 'メールアドレス',
      label: '必須',
      questionMark: false,
      type: 'TextInput',
      input: <>
        <TextInput
          name='email'
          val={email}
          onChange={onChangeEmail}
          placeholder='haken@r-staffing.co.jp'
          inValid={!!dispErrors().email}
        />
        <PcErrorArea message={dispErrors().email} />
      </>,
    },
    {
      title: '派遣先住所',
      subTitle: '派遣スタッフが実際に就業する住所を、番地・建物名まで記載してください。',
      label: '必須',
      questionMark: false,
      type: 'TextInput',
      input: <>
        <TextInput
          name='address'
          val={address}
          onChange={onChangeAddress}
          placeholder='東京都千代田区有楽町1‐13‐1 〇〇ビル19F'
          maxLength='300'
          inValid={!!dispErrors().address}
        />
        <div className='address'>
          <PcErrorArea position='relative' message={dispErrors().address} /> 
        </div>
      </>,
    },
    {
      title: '派遣先最寄り駅',
      label: '必須',
      questionMark: false,
      popUpTitle: null,
      popUpDetail: null,
      type: 'TextInput',
      input: <>
        <TextInput
          name='ekiName'
          val={ekiName}
          onChange={onChangeEkiname}
          placeholder='駅名'
          inValid={!!dispErrors().ekiName}
          suggestText
        />
        <PcErrorArea position='custom' message={dispErrors().ekiName} />
        {/* 駅サジェストエリア */}
        <div className="searchNamesWrapper">
          <div className="searchNames">
            {isSp ?
              <SpSuggestList
                items={ekiSuggestNames.map(x => x.ekiNm)}
                onClick={onClickEkiSuggest}
              />
              :
              <PcSuggestList
                items={ekiSuggestNames.map(x => x.ekiNm)}
                onClick={onClickEkiSuggest}
                fullWidth
              />
            }
          </div>
        </div>
      </>,
    },
    {
      title: '紹介予定派遣のみの希望',
      label: '任意',
      questionMark: null,
      popUpTitle: '紹介予定派遣について',
      popUpDetail: (
        <span>
          <p>
            「紹介予定派遣」とは、社員として採用することを前提に、派遣社員を一定期間受入、派遣期間中に社員としての適性を見極めることができる仕組みです。
            <br />
            <br />
            詳細は
            <a className="link-grey" href="/sol/contents/client/ttoh/" target="_blank" rel="noopener noreferrer">こちら</a>
          </p>
        </span>
      ),
      type: 'TextInput',
      input: <>
        <BasicCheckBoxInput
          id='employmentPlacementDispatching'
          value={employmentPlacementDispatching}
          label={CHOICES_MAP.employmentPlacementDispatchingLabel}
          onChange={onChangeEmploymentPlacementDispatching}
          checked={employmentPlacementDispatching}
        />
      </>,
    },
    {
      title: 'ご依頼内容の詳細',
      label: '任意',
      questionMark: false,
      popUpTitle: '',
      popUpDetail: '',
      input: <>
        <TextAreaInput
          name='workDetailText'
          value={workDetailText}
          onChange={onChangeWorkDetailText}
          maxLength='500'
          inValid={!!dispErrors().workDetailText}
          suggestText={false}
          placeholder='例）
業務内容：営業アシスタント（受発注業務/見積書作成/請求処理/データ集計など）
期間：20xx年4月1日より1年間
人数：2名
勤務時間：9時～17時、週5日勤務（土日祝休み）
残業：5~10時間／月（繁忙期10～20時間／月）
必要スキル：Excelで表、グラフが作成できる方'
        />
        <div className='word-count'>(500文字以下)</div>
        <PcErrorArea position='custom' message={dispErrors().workDetailText} />
      </>,
    }
  ];

  const howToDoAreaDisp = {
    title: '依頼方法',
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.howToDo.map((elem, index) => {
      return {
        value: elem.value,
        label: elem.label,
        subLabel: elem.subLabel,
        point: elem.point,
        id: 'howToDo' + elem.value,
        onChange: howToDoOnChange,
        checked: howToDo === elem.value,
        icon: index === 0 ? 'icon_sentaku2' : 'icon_sentaku1',
      };
    }),
    type: 'HowToDo',
  };

  const bgdOfRecruitmentDisp = {
    title: '募集背景',
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.bgdOfRecruitmentList.map((elem) => {
      const infoStr = 'bgdOfRecruitment';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: bgdOfRecruitmentOnChange,
        checked: bgdOfRecruitment.includes(elem.value),
        name: infoStr,
        number: isSp ? null : 3,
      };
    }),
    type: 'RadioInput',
    isLine: false,
    comment: {
      title: COMMENT_MAP.bgdOfRecruitmentCmnt.title,
      visible: bgdOfRecruitment.includes(COMMENT_MAP.bgdOfRecruitmentCmnt.value),
      label: CHOICES_NAME_MAP.require,
      questionMark: false,
      popUpTitle: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpDetail,
      name: 'bgdOfRecruitmentCmnt',
      textAreaValue: bgdOfRecruitmentCmnt,
      cmntOnChange: onChangeBgdOfRecruitmentCmnt,
      onInput: onChangeBgdOfRecruitmentCmnt,
      onCompositionEnd: onChangeBgdOfRecruitmentCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      inValid: dispErrors().bgdOfRecruitmentCmnt,
      errMessage: dispErrors().bgdOfRecruitmentCmnt,
      relativePosArrow: isSp ? "25%" : null,
    },
  };

  const desiredStartDateDisp = {
    title: '就業開始日',
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.desiredStartDateKubunList.map((elem, index) => {
      const infoStr = 'desiredStartDate';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: desiredStartDateOnChange,
        handleChange: handleChangedesiredStartDate,
        checked: desiredStartDateKubun
          ? desiredStartDateKubun.includes(elem.value)
          : false,
        name: infoStr,
        number: isSp ? null : 3,
        isCalendarRadio: index === 2,
      };
    }),
    type: 'RadioInput',
    selectedDate: desiredStartDate ? new Date(desiredStartDate) : desiredStartDate,
  };

  const workPeriodDisp = {
    title: '就業期間',
    subTitle: '',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.workPeriodList.map((elem, index) => {
      const infoStr = 'workPeriod';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: workPeriodOnChange,
        handleChange: handleChangeWorkPeriodDate,
        checked: workPeriod
          ? workPeriod.includes(elem.value)
          : false,
        name: infoStr,
        number: isSp ? null : 3,
        isCalendarRadio: index === 2,
      };
    }),
    type: 'RadioInput',
    selectedDate: workPeriodDate ? new Date(workPeriodDate) : workPeriodDate,
  };

  const workInfoDips = [
    desiredStartDateDisp,
    workPeriodDisp,
  ];


  return isSp ? (
    <PresentSP
      // state
      workCategory={workCategory}
      workCategoryOtherDetail={workCategoryOtherDetail}

      WorkCategoryList={WorkCategoryList}
      basicInfoList={basicInfoList}

      howToDo={howToDo}
      workInfoDips={workInfoDips}
      bgdOfRecruitmentDisp={bgdOfRecruitmentDisp}
      howToDoAreaDisp={howToDoAreaDisp}

      // onChange
      onChangeWorkCategory={onChangeWorkCategory}
      onChangeWorkCategoryOtherDetail={onChangeWorkCategoryOtherDetail}
      modalBackIsEnable={modalBackIsEnable}
      // onClick
      onClickMainButton={onClickMainButton}
  
      // valid
      valid={valid}
      addInputValid={addInputValid}
      inputValid={inputValid}
      showLoading={showLoading}
      errorDispMap={dispErrors()}
      isApiError={isApiError}
    /> 
  ) : (
    <PresentPC
      // state
      workCategory={workCategory}
      workCategoryOtherDetail={workCategoryOtherDetail}

      WorkCategoryList={WorkCategoryList}
      basicInfoList={basicInfoList}

      howToDo={howToDo}
      workInfoDips={workInfoDips}
      bgdOfRecruitmentDisp={bgdOfRecruitmentDisp}
      howToDoAreaDisp={howToDoAreaDisp}

      // onChange
      onChangeWorkCategory={onChangeWorkCategory}
      onChangeWorkCategoryOtherDetail={onChangeWorkCategoryOtherDetail}
      modalBackIsEnable={modalBackIsEnable}

      // onClick
      onClickMainButton={onClickMainButton}

      // valid
      valid={valid}
      addInputValid={addInputValid}
      inputValid={inputValid}
      showLoading={showLoading}
      errorDispMap={dispErrors()}
      isApiError={isApiError}
    />
  );

};

export default Input;